import { ReactElement } from 'react'
import { Page } from '../../../../NonReact/constants/Components/Page'

/**
 * Expansion panel item type.
 */
export type ExpansionPanelItem = {
    id?: Page
    title: ReactElement
    content: ReactElement
    isExpanded?: boolean
    onChange?: (isNewlyExpanded: boolean) => void
}
